// import "../stylesheets/Footer.css"; // Converting to Tailwind
import { useState, useContext, useEffect } from "react";
import FeedbackForm from "./FeedbackForm";
import { LoginContext } from "../LoginContext";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const { loginInfo } = useContext(LoginContext);
  const { t } = useTranslation();

  useEffect(() => {
    if (loginInfo) setShowMessage(false);
  }, [loginInfo]);

  return (
    <>
      {/* Feedback-Popup */}
      {showFeedback && (
        <div className="fixed inset-0 w-screen h-screen bg-black/70 backdrop-blur-md flex items-center justify-center z-[9999] animate-in fade-in duration-300 overflow-hidden"
          onClick={(e) => {
            if (e.target.classList.contains('fixed')) {
              setShowFeedback(false);
            }
          }}>
          <FeedbackForm
            className="bg-white rounded-[20px] shadow-2xl w-full max-w-[500px] overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-5 duration-400"
            loggedInUser={loginInfo}
            onClose={() => setShowFeedback(false)}
            folder="footer-feedback"
          />
        </div>
      )}

      <div className="w-full bg-gradient-to-b from-[#0f172a] to-[#1e293b] text-white flex flex-col items-center m-0 p-0 mt-auto relative shadow-[0_-4px_20px_rgba(0,0,0,0.1)]
        before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-[2px] before:bg-gradient-to-r before:from-transparent before:via-[#4c9fb9] before:to-transparent">
        <div className="w-full p-[60px_30px_30px] box-border sm:p-[40px_20px_20px]">
          <div className="flex flex-col sm:flex-row justify-center flex-wrap gap-20 sm:gap-12 lg:gap-20 max-w-[1200px] mx-auto w-full">
            {/* Column 1 */}
            <div className="flex-1 min-w-[220px] max-w-[350px] sm:max-w-none text-center w-full">
              <h4 className="text-[1.1rem] mb-6 font-bold relative pb-3 text-[#4c9fb9] tracking-[0.5px]
                after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-[50px] after:h-[3px] after:bg-gradient-to-r after:from-transparent after:via-[#4c9fb9] after:to-transparent after:rounded-full">
                {t("footer.aboutUs")}
              </h4>
              <div className="mb-8 last:mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">{t("3D-Medico")}</h5>
                <p className="text-[0.875rem] m-0 leading-[1.8] text-white/70">{t("footer.feedbackDescription")}</p>
              </div>
              <div className="mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">{t("footer.feedbackTitle")}</h5>
                <p className="text-[0.875rem] m-0 leading-[1.8] text-white/70">
                  {t("footer.feedbackDescription")}
                </p>
                <div className="mt-[15px] text-center">
                  <button
                    className="bg-gradient-to-br from-[#0f7699] to-[#4c9fb9] text-white border-none text-[0.95rem] px-6 py-2.5 rounded-full cursor-pointer transition-all duration-300 font-semibold shadow-[0_4px_12px_rgba(15,118,153,0.3)] tracking-[0.3px] hover:from-[#0a5f7a] hover:to-[#0f7699] hover:-translate-y-0.5 hover:shadow-[0_6px_16px_rgba(15,118,153,0.4)] active:translate-y-0"
                    onClick={() => {
                      if (!loginInfo) setShowMessage(true);
                      else {
                        setShowMessage(false);
                        setShowFeedback(true);
                      }
                    }}
                  >
                   {t("feedback senden")}
                  </button>
                  {showMessage && (
                    <p className="text-[#fbbf24] text-[0.8rem] mt-2 font-semibold">Bitte zuerst einloggen!</p>
                  )}
                </div>
              </div>
            </div>

            {/* Column 2 */}
            <div className="flex-1 min-w-[220px] max-w-[350px] sm:max-w-none text-center w-full">
              <h4 className="text-[1.1rem] mb-6 font-bold relative pb-3 text-[#4c9fb9] tracking-[0.5px]
                after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-[50px] after:h-[3px] after:bg-gradient-to-r after:from-transparent after:via-[#4c9fb9] after:to-transparent after:rounded-full">
                {t("contact Location")}
              </h4>
              <div className="mb-8 last:mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">{t("post Address")}</h5>
                <p className="text-[0.875rem] m-0 leading-[1.8] text-white/70">
                  3D-Medico
                  <br />
                  Teutonenstraße 74
                  <br />
                  12524 Berlin
                </p>
              </div>
              <div className="mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">{t("workplace")}</h5>
                <p className="text-[0.875rem] m-0 leading-[1.8] text-white/70">
                  c/o ST3AM Adlershof
                  <br />
                  Rudower Chaussee 28/1. OG
                  <br />
                  12489 Berlin
                </p>
                <p className="text-[0.75rem] italic mt-2.5 opacity-70 text-white/50">{t("footer.appointmentNote")}</p>
              </div>
            </div>

            {/* Column 3 */}
            <div className="flex-1 min-w-[220px] max-w-[350px] sm:max-w-none text-center w-full">
              <h4 className="text-[1.1rem] mb-6 font-bold relative pb-3 text-[#4c9fb9] tracking-[0.5px]
                after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-[50px] after:h-[3px] after:bg-gradient-to-r after:from-transparent after:via-[#4c9fb9] after:to-transparent after:rounded-full">
                {t("connection")}
              </h4>
              <div className="mb-8 last:mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">{t("Communication")}</h5>
                <p className="text-[0.875rem] m-0 leading-[1.8] text-white/70">
                  E-Mail: info@3d-medico.de
                  <br />
                  Tel: +49 (0)152 3665 2844
                </p>
              </div>
              <div className="mb-8 last:mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">{t("important Links")}</h5>
                <div className="flex flex-col items-center gap-2.5">
                  <a
                    href="https://3d-medico.de/kontakt.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block text-white/70 no-underline text-sm transition-all duration-300 py-1 relative hover:text-[#4c9fb9] hover:pl-2 before:content-['→'] before:mr-1.5 before:transition-transform before:duration-300 before:inline-block hover:before:translate-x-1"
                  >
                    {t("contact")}
                  </a>
                  <a
                    href="https://3d-medico.de/impressum.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block text-white/70 no-underline text-sm transition-all duration-300 py-1 relative hover:text-[#4c9fb9] hover:pl-2 before:content-['→'] before:mr-1.5 before:transition-transform before:duration-300 before:inline-block hover:before:translate-x-1"
                  >
                    {t("imprint")}
                  </a>
                  <a
                    href="https://3d-medico.de/3d-scan.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block text-white/70 no-underline text-sm transition-all duration-300 py-1 relative hover:text-[#4c9fb9] hover:pl-2 before:content-['→'] before:mr-1.5 before:transition-transform before:duration-300 before:inline-block hover:before:translate-x-1"
                  >
                    Video 3D-Scan Info
                  </a>
                </div>
              </div>
              <div className="mb-0">
                <h5 className="text-[0.95rem] mb-2.5 font-semibold text-white/90">Follow Us</h5>
                <div className="flex justify-center gap-3 mt-3">
                  <a
                    href="https://linkedin.com/company/3d-medico"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white/70 transition-all duration-300 no-underline hover:bg-[#4c9fb9] hover:text-white hover:-translate-y-[3px] hover:shadow-[0_4px_12px_rgba(76,159,185,0.4)]"
                    title="LinkedIn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                  </a>
                  <a
                    href="https://twitter.com/3dmedico"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white/70 transition-all duration-300 no-underline hover:bg-[#4c9fb9] hover:text-white hover:-translate-y-[3px] hover:shadow-[0_4px_12px_rgba(76,159,185,0.4)]"
                    title="Twitter"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                    </svg>
                  </a>
                  <a
                    href="https://facebook.com/3dmedico"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white/70 transition-all duration-300 no-underline hover:bg-[#4c9fb9] hover:text-white hover:-translate-y-[3px] hover:shadow-[0_4px_12px_rgba(76,159,185,0.4)]"
                    title="Facebook"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                    </svg>
                  </a>
                  <a
                    href="https://instagram.com/3dmedico"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white/70 transition-all duration-300 no-underline hover:bg-[#4c9fb9] hover:text-white hover:-translate-y-[3px] hover:shadow-[0_4px_12px_rgba(76,159,185,0.4)]"
                    title="Instagram"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.163zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                  <a
                    href="https://youtube.com/@3dmedico"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white/70 transition-all duration-300 no-underline hover:bg-[#4c9fb9] hover:text-white hover:-translate-y-[3px] hover:shadow-[0_4px_12px_rgba(76,159,185,0.4)]"
                    title="YouTube"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent w-[90%] max-w-[900px] mx-auto mb-5 mt-10"></div>
          <div className="w-full p-5 text-center box-border">
            <p className="text-[0.875rem] m-0 text-white/50">{t("footer.copyright", { year: new Date().getFullYear() })}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
